<template>
  <div
    class="grid grid-rows-[auto_1fr_auto] overflow-hidden h-full w-full font-[Cubic]"
  >
    <ThreadsNav :show-back="true" :show-center="false">
      <template #right>
        <CrystalPowerCount />
      </template>
    </ThreadsNav>
    <div v-if="loading" class="flex justify-center items-center h-full">
      <div class="loading loading-ring loading-lg"></div>
    </div>
    <div v-else class="h-full w-full grid grid-rows-[auto_1fr] overflow-hidden">
      <VanTabs v-model:active="activeTab">
        <VanTab title="任务" name="mission" />
        <VanTab title="世界观" name="worldview" />
      </VanTabs>
      <div v-if="activeTab === 'mission'" class="pb-4 overflow-auto flex-1">
        <!-- 人员选择 -->
        <MissionParticipantsSelect
          :dispatch-mission="dispatchMission"
          :is-edit="isEdit"
          v-model:active-mate="leaderMate"
          show-action
          :type="type"
          :reset-objective-when-change-member="false"
        />

        <template v-if="dispatchMission.type === DispatchType.Mission">
          <div class="flex flex-col gap-4">
            <!-- 外派任务类型 -->
            <MissionCardSelect
              :dispatch-mission="dispatchMission"
              :is-edit="false"
            />

            <!-- 地点选择 -->
            <MissionLocationSelect
              :dispatch-mission="dispatchMission"
              :is-edit="false"
              is-world-mission
            />

            <div class="px-1" v-if="dispatchMission.difficultyLevel && !isEdit">
              <MissionEditBottomSeason
                :dispatch-mission="dispatchMission"
                show-detail
              />
            </div>
          </div>
        </template>
        <template v-else-if="dispatchMission.type === DispatchType.Stroll">
          <!-- 携带物品 -->
          <MissionEquipmentSelect
            :dispatch-mission="dispatchMission"
            :is-edit="isEdit"
          />
        </template>
      </div>
      <div v-else-if="activeTab === 'worldview'" class="overflow-auto flex-1">
        <WorldMissionCard
          class="bg-base-300"
          :worldview="dispatchTemplate!.location!.worldview!"
        />
        <RedotTitle title="事件" class="ml-4 my-2" />
        <TimelineModuleList
          :timeline-events="dispatchTemplate!.location!.worldview!.timelineEventzz"
          mode="preview"
          :event-loading="false"
        />
      </div>
      <div
        class="bg-base-100 border-t flex justify-between p-3 items-center gap-2 text-xs w-full"
      >
        <template
          v-if="
            [
              DispatchStatus.Settled,
              DispatchStatus.Returned,
            ].includes(dispatchMission.status!)
          "
        >
          <div class="flex items-center gap-2 justify-between w-full">
            <div
              v-if="!dispatchMission.difficultyLevel"
              class="flex items-center gap-2 text-success"
            >
              <i class="iconify mingcute--check-circle-line"></i>
              <p>该任务已结束</p>
            </div>
            <div
              v-else-if="dispatchMission.isSuccess"
              class="flex items-center gap-2 text-success"
            >
              <i class="iconify mingcute--check-circle-line"></i>
              <p>该任务已成功</p>
            </div>
            <div v-else class="flex items-center gap-2 text-error">
              <i class="iconify mingcute--close-circle-line"></i>
              <p>该任务已失败</p>
            </div>

            <button
              class="btn btn-xs btn-outline"
              v-if="
                dispatchMission.type === DispatchType.Mission && isMyMission
              "
              @click="clickCreateSceneMemory"
            >
              +记忆
            </button>
          </div>
        </template>

        <!-- 别邀请人的状态 -->
        <template v-if="isParticipate">
          <div
            v-if="
              [
                DispatchStatus.Dispatched,
                DispatchStatus.ReturningWithLoots,
              ].includes(dispatchMission.status!)
            "
            class="text-success flex items-center gap-2"
          >
            <i class="iconify mingcute--check-circle-line"></i>
            <p>该任务正在进行中...</p>
          </div>

          <div
            v-else-if="dispatchMission.status === DispatchStatus.Preparing"
            class="text-error flex items-center gap-2"
          >
            <i class="iconify mingcute--close-circle-line"></i>
            <p>该房间已失效，请等待领队重新发起邀约</p>
          </div>

          <div
            v-else-if="dispatchMission.status === DispatchStatus.Canceled"
            class="text-error flex items-center gap-2"
          >
            <i class="iconify mingcute--close-circle-line"></i>
            <p>该房间已被领队取消，请等待领队重新发起邀约</p>
          </div>

          <div
            v-else-if="
              dispatchMission.status === DispatchStatus.AwaitingInviteeResponse
            "
            class="flex items-center gap-2 justify-end w-full"
          >
            <!-- 接受或拒绝 -->
            <template
              v-if="
                activeDispatchMember?.invitation?.status ===
                InvitationStatus.Pending
              "
            >
              <button
                class="btn btn-success btn-sm"
                @click="clickRespond(InteractionEventStatus.Approved)"
              >
                接受
                <template v-if="isFree">
                  <span class="text-success-content/80">(领队已为您买单)</span>
                </template>
                <template v-else-if="!userStore.isFreeModel()">
                  <PowerIcon />
                  {{ userStore.getPowerCostByModel(totalPower || 0) }}
                </template>
              </button>
              <button
                class="btn btn-error btn-sm"
                @click="clickRespond(InteractionEventStatus.Rejected)"
              >
                拒绝
              </button>
            </template>
            <button
              v-else-if="
                activeDispatchMember?.invitation?.status ===
                InvitationStatus.Accepted
              "
              class="btn btn-success btn-sm btn-outline"
            >
              已接受邀请
            </button>
            <button
              v-else-if="
                activeDispatchMember?.invitation?.status ===
                InvitationStatus.Rejected
              "
              class="btn btn-error btn-sm btn-outline"
            >
              已拒绝邀请
            </button>
          </div>
        </template>

        <!-- 领队的状态 -->
        <template v-else>
          <!-- 等待随行人员反馈的状态 -->
          <div
            v-if="
              DispatchStatus.AwaitingInviteeResponse === dispatchMission.status
            "
            class="flex gap-2 items-center justify-between w-full"
          >
            <p>当所有随行人员接受后，任务将自动开启</p>
            <button class="btn btn-primary btn-sm" @click="clickCancelInvite">
              取消邀请
            </button>
          </div>

          <!-- 准备中的状态 -->
          <div
            v-else-if="DispatchStatus.Preparing === dispatchMission.status"
            class="flex gap-2 items-center justify-between w-full"
          >
            <p>请编辑并发起任务</p>
            <div class="flex gap-2">
              <button class="btn btn-outline btn-sm" @click="clickCancelInvite">
                取消任务
              </button>
              <button
                class="btn btn-primary btn-sm"
                @click="detailCovertToEdit"
              >
                编辑
              </button>
            </div>
          </div>

          <MissionEditBottom
            v-else-if="isEdit"
            :dispatch-mission="dispatchMission"
            :leader-mate="leaderMate"
            :is-edit="isEdit"
            force-show
            is-world-mission
          />

          <!-- 倒计时状态 -->
          <div
            v-else-if="countDownStr !== '-1'"
            class="flex flex-col gap-1 w-full"
          >
            <button class="btn btn-outline btn-sm whitespace-nowrap">
              {{ countDownStr }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  DispatchMemberPayerType,
  DispatchMemberType,
  MemoryType,
} from "@/enums/mateEnums";
import {
  DispatchStatus,
  DispatchType,
  InteractionEventStatus,
  InvitationStatus,
} from "@/enums/mission";
import api from "@/modules/api";
import { useGlobalUser } from "@/stores/globalUser";
import { useInteractiveReview } from "@/stores/interactive-review";
import { useMate } from "@/stores/mate";
import { useMission } from "@/stores/mission";
import { sessionStorageSet } from "@/tools/sessionStorage";
import {
  DispatchTemplate,
  Mate,
  MateDispatch,
  MateDispatchMember,
} from "@/types/entity";
import { useRouteQuery } from "@vueuse/router";
import moment from "moment-timezone";
import { showLoadingToast } from "vant";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import WorldMissionCard from "./WorldMissionCard.vue";
import TimelineModuleList from "@/components/mobile/modules/TimelineModuleList.vue";
import RedotTitle from "@/components/mobile/common/titles/RedotTitle.vue";

// 这里可以添加需要的逻辑代码

const { t } = useI18n();
const isEdit = ref(true);
const route = useRoute();
const router = useRouter();
const uuid = useRouteQuery("uuid", "");

const missionStore = useMission();
const reviewStore = useInteractiveReview();
const mateStore = useMate();
const leaderMate = ref<Mate>();
const userStore = useGlobalUser();
const dispatchTemplate = ref<DispatchTemplate | null>(null);
const dispatchMission = ref<MateDispatch & { objectiveSignature: string }>(
  defaultDispatchMission() as MateDispatch & { objectiveSignature: string }
);
const activeTab = ref<"mission" | "worldview">("mission");
const activeDispatchMember = computed(() => {
  const invitationId = Number(route.query.invitationId);
  if (invitationId)
    return dispatchMission.value.dispatchMemberzz?.find(
      (v) => v.invitationId === Number(route.query.invitationId)
    );

  return dispatchMission.value.dispatchMemberzz?.find((v) =>
    mateStore.isMyMateById(v.mateId)
  );
});

const isMyMission = computed(() => {
  return dispatchMission.value.dispatchMemberzz?.some((v) =>
    mateStore.isMyMateById(v.mate?.id)
  );
});

const isParticipate = computed(() => {
  // const dispatchMember = activeDispatchMember.value;
  // if (dispatchMember) return mateStore.isMyMateById(dispatchMember.mateId);
  if (leaderMate.value) return !mateStore.isMyMateById(leaderMate.value.id);
  if (!dispatchMission.value.mateId) return false;
  return !mateStore.isMyMateById(dispatchMission.value.mateId);
});

// watch(
//   () => dispatchMission.value,
//   (val) => {
//     if (isEdit.value) {
//       StorageSet(`dispatchMission:${val.type}`, val);
//     }
//   },
//   {
//     deep: true,
//   }
// );

function defaultDispatchMission(type: DispatchType = DispatchType.Stroll) {
  const v = {
    carriedEquipmentzz: [],
    carriedJournalzz: [],
    type,
    carriedMailzz: [],
    dispatchMemberzz: [],
    carriedMemoryzz: [],
  } as Partial<MateDispatch>;

  v.mateId = leaderMate.value?.id;

  if (type === DispatchType.Mission) {
    v.mission = undefined;
    v.duration = 2;
  } else {
    v.duration = 5;
  }

  if (leaderMate.value) {
    v.dispatchMemberzz = [
      {
        mate: leaderMate.value!,
        type: DispatchMemberType.Leader,
      } as MateDispatchMember,
    ];
  }

  return v;
}

const isFree = computed<boolean>(() => {
  if (dispatchMission.value) {
    const activeMember = dispatchMission.value.dispatchMemberzz?.find(
      (v) => v.mateId === Number(route.query.mateId)
    );

    if (activeMember?.payerType === DispatchMemberPayerType.Host) {
      return true;
    }
  }
  return false;
});
const totalPower = computed(() => {
  return dispatchMission.value.costPowerCubes;
});

let timer: NodeJS.Timeout | null = null;
const countDownStr = ref("");
const updateCountdown = () => {
  const { dtReturn } = dispatchMission.value;
  if (dtReturn) {
    const now = moment();
    const endTime = moment(dtReturn);
    const allSecond = endTime.diff(now, "second");
    if (allSecond <= 0) {
      clearInterval(timer!);
      countDownStr.value = "-1";
      initDispatch();
    } else {
      const minute = String(Math.floor(allSecond / 60)).padStart(2, "0");
      const second = String(allSecond % 60).padStart(2, "0");
      countDownStr.value = t(`mission.statusBtnMap.countDown`, {
        minute,
        second,
      });
    }
  }
};

// 接受或拒绝
const clickRespond = async (
  status: InteractionEventStatus.Approved | InteractionEventStatus.Rejected
) => {
  const loading = showLoadingToast(t(`Message.loading`));
  const id = Number(route.query.eventId);
  if (!id) return;
  await reviewStore.reviewEvent(
    id,
    status,
    !isFree.value && status === InteractionEventStatus.Approved
      ? totalPower.value
      : 0
  );

  await initDispatch();

  sessionStorageSet("mission-home:reload", true);

  if (status === InteractionEventStatus.Approved) userStore.refresh();

  loading.close();
};

const clickCancelInvite = async () => {
  const loading = showLoadingToast(t(`Message.loading`));
  if (!dispatchMission.value.id) return;
  await missionStore.cancelInvitation(dispatchMission.value.id!);
  detailCovertToEdit();
  loading.close();
};

const detailCovertToEdit = async () => {
  loading.value = true;
  await Promise.all([
    missionStore.getMissionList(),
    missionStore.getMateEquipmentList(),
  ]);
  isEdit.value = true;
  dispatchMission.value.status = undefined;
  loading.value = false;
};

const initDispatch = async () => {
  const dispatchUuid = route.query.dispatchUuid as string;
  if (dispatchUuid) {
    dispatchMission.value = (await missionStore.getMateDispatch(
      dispatchUuid,
      undefined
    )) as MateDispatch & { objectiveSignature: string };
  } else {
    dispatchMission.value = defaultDispatchMission() as MateDispatch & {
      objectiveSignature: string;
    };
  }
};

const clickCreateSceneMemory = () => {
  sessionStorageSet("memory:edit:source", {
    dispatchzz: [dispatchMission.value],
  });

  let mateId = dispatchMission.value.mateId;
  if (!mateStore.isMyMateById(mateId)) {
    dispatchMission.value.dispatchMemberzz?.some((v) => {
      if (mateStore.isMyMateById(v.mate?.id)) {
        mateId = v.mate!.id!;
        return true;
      }
    });
  }

  router.push({
    name: "mateMemoryEdit",
    query: {
      type: MemoryType.Scene,
      mateId,
      hasSource: 1,
    },
  });
};

onUnmounted(() => {
  if (timer) clearInterval(timer);
});

const loading = ref(true);
const type = ref<"rank" | undefined>();

onMounted(async () => {
  isEdit.value = route.name === "worldMissionEdit";
  loading.value = true;

  if (isEdit.value) {
    await Promise.all([
      // missionStore.getMissionList(),
      // missionStore.getMateEquipmentList(),
      loadDispatchTemplate(),
    ]);
    const missions = missionStore.missionList;
    if (missions && missions.length > 0) {
      const randomIndex = Math.floor(Math.random() * missions.length);
      dispatchMission.value.mission = missions[randomIndex];
    }
  } else if (route.name === "missionDetail") {
    if (route.query.type === "rank") {
      type.value = "rank";
    }
    await initDispatch();
    leaderMate.value = mateStore.getMyMateById(dispatchMission.value.mateId!);
    timer = setInterval(updateCountdown, 1000);
    updateCountdown();
    if (
      route.query.isEdit ||
      (dispatchMission.value.status === DispatchStatus.Canceled &&
        mateStore.isMyMateById(dispatchMission.value.mateId))
    ) {
      detailCovertToEdit();
    }
  }

  loading.value = false;
});

const loadDispatchTemplate = async () => {
  if (!uuid.value) return;
  const res = await api.readOneDispatchTemplate(uuid.value);
  dispatchTemplate.value = res.item;
  // dispatchMission.value = {
  //   locationId: res.item.locationId,
  //   location: res.item.location,
  //   type: DispatchType.Mission,
  //   id: undefined as unknown as number,
  //   dispatchTemplateId: res.item.id,
  //   duration: 2,
  //   isRankingEnabled: true,
  // };
  dispatchMission.value = {
    ...res.item,
    id: undefined,
    dispatchTemplateId: res.item.id,
    isRankingEnabled: true,
  } as MateDispatch;
};
</script>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.equipment-item.grayscale .mingcute--check-circle-fill {
  display: none;
}
</style>
